export const setScore = (value) => ({
	type: 'UPDATE_CURRENT_ROUND_POINTS',
	value,
});

export const resetScore = () => ({
	type: 'RESET_SCORE',
});

export const setRoundsScore = ({ ourRounds, opponentRounds }) => ({
	type: 'UPDATE_ROUNDS_SCORE',
	ourRounds,
	opponentRounds,
});

export const setHandPoints = ({ ourPoints, opponentPoints }) => ({
	type: 'UPDATE_HAND_POINTS',
	ourPoints,
	opponentPoints,
});

export const setRoundsToWin = (value) => ({
	type: 'SET_ROUNDS_TO_WIN',
	value,
});
